var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.364 58.003C117.045 58.5812 114.422 62.3596 114.801 66.2203L109.344 68.2814C107.949 68.8081 106.379 68.3544 105.477 67.1666C103.446 64.492 100.962 62.2556 98.1844 60.5168C96.7337 59.6077 96.1418 57.799 96.8466 56.2387L99.4779 50.4139C99.6281 50.3745 99.7814 50.3492 99.9296 50.2932C102.668 49.2591 103.836 45.8845 102.019 43.3031C101.101 41.9995 99.4752 41.2651 97.8904 41.4381C94.7513 41.779 92.9921 44.8882 94.0262 47.6264C94.1203 47.8754 94.243 48.1026 94.3745 48.3243L91.496 54.6963C90.8704 56.0812 89.3987 56.8758 87.8997 56.632C83.3048 55.8834 78.4613 56.2817 73.7924 58.0449C73.4351 58.1798 73.0834 58.3235 72.7364 58.4741C71.1052 59.1857 69.209 58.4536 68.4179 56.859L65.6597 51.2977C66.9044 49.1949 67.0348 46.4641 65.4745 44.1091C64.0311 41.9315 61.3179 40.7783 58.7483 41.2472C54.4746 42.0274 52.1421 46.3954 53.6018 50.2605C54.7672 53.3465 57.9557 55.0627 61.0909 54.4931L64.2756 60.9138C64.9041 62.1811 64.6782 63.7103 63.6968 64.728C61.7305 66.7712 60.1035 69.0922 58.8581 71.6014C58.1059 73.1166 56.3914 73.8835 54.78 73.3652L50.2243 71.8982C48.9969 69.6715 46.0773 68.7939 43.7454 70.352C42.4118 71.2421 41.6397 72.8713 41.8098 74.4659C42.1372 77.5579 45.1967 79.2946 47.8912 78.277C48.4347 78.0717 48.9092 77.7644 49.3159 77.3981L53.7036 78.8112C55.1718 79.2837 56.1201 80.6909 56.0283 82.2302C55.8036 85.9759 56.3382 89.8234 57.7498 93.5612C58.1258 94.5569 58.5569 95.5145 59.0348 96.4349C59.8054 97.9178 59.4563 99.7302 58.129 100.746L50.9271 106.26C49.0284 105.366 46.7139 105.361 44.6713 106.593C42.3794 107.975 41.1308 110.763 41.6291 113.393C42.4187 117.549 46.6791 119.809 50.4492 118.385C53.653 117.175 55.3287 113.741 54.451 110.503L61.7353 104.925C62.9864 103.966 64.7251 104.011 65.9385 105.016C68.6968 107.301 71.8668 109.02 75.2633 110.091C76.7396 110.556 77.714 111.957 77.6199 113.502L76.9577 124.524C74.831 125.809 74.0373 128.686 75.5929 130.971C76.4908 132.291 78.1142 133.048 79.7005 132.879C82.7949 132.546 84.532 129.482 83.513 126.784C83.2733 126.149 82.8978 125.609 82.4432 125.164L83.0902 114.396C83.1904 112.712 84.5194 111.396 86.1987 111.237C88.5613 111.014 90.9344 110.484 93.2622 109.605C93.4865 109.521 93.7074 109.433 93.9249 109.342C95.4303 108.717 97.1581 109.222 98.0545 110.583L103.013 118.114C102.248 119.763 102.259 121.767 103.33 123.534C104.532 125.516 106.945 126.594 109.223 126.163C112.839 125.48 114.805 121.775 113.566 118.495C112.608 115.959 110.042 114.511 107.463 114.851L102.61 107.478C101.729 106.141 101.921 104.379 103.049 103.243C105.172 101.104 106.914 98.6436 108.226 95.9724C108.889 94.6215 110.363 93.8756 111.844 94.1458L115.678 94.8408C117.05 97.4192 120.446 98.4098 123.083 96.4804C124.437 95.4892 125.195 93.7828 125.033 92.1114C124.694 88.6612 121.291 86.7175 118.297 87.8485C117.459 88.1649 116.774 88.6972 116.239 89.3398L113.78 88.8941C112.083 88.5861 110.924 87.0523 111.023 85.3301C111.178 82.6074 110.932 79.8297 110.237 77.0807C109.814 75.4016 110.678 73.6724 112.299 73.0602L117.354 71.1513C119.376 72.9018 122.248 73.5435 124.926 72.5323C129.365 70.8559 131.293 65.4354 128.478 61.2181C126.937 58.9099 124.111 57.6345 121.364 58.003Z",
    fill: "url(#paint0_linear_1_1139)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 106.286C125.883 107.039 124.876 109.267 125.63 111.262C126.383 113.258 128.611 114.264 130.606 113.511C132.602 112.757 133.608 110.529 132.855 108.534C132.101 106.539 129.873 105.532 127.878 106.286Z",
    fill: "url(#paint1_linear_1_1139)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1894 61.1617C39.9065 60.1355 41.2773 57.1011 40.2512 54.3839C39.2251 51.6668 36.1906 50.296 33.4735 51.3222C30.7564 52.3483 29.3856 55.3828 30.4117 58.0999C31.4378 60.817 34.4723 62.1878 37.1894 61.1617Z",
    fill: "url(#paint2_linear_1_1139)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3611 131.827C64.2596 131.111 65.2175 128.99 64.5005 127.092C63.7835 125.193 61.6632 124.235 59.7647 124.952C57.8662 125.669 56.9084 127.79 57.6254 129.688C58.3423 131.587 60.4626 132.544 62.3611 131.827Z",
    fill: "url(#paint3_linear_1_1139)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1139",
    x1: 57.8394,
    y1: 139.846,
    x2: 77.8394,
    y2: 25.3178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1139",
    x1: 127.27,
    y1: 114.31,
    x2: 128.945,
    y2: 105.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1139",
    x1: 32.645,
    y1: 62.2498,
    x2: 34.9261,
    y2: 50.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1139",
    x1: 59.1858,
    y1: 132.588,
    x2: 60.7797,
    y2: 124.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white",
    transform: "translate(0 45.929) rotate(-20.6893)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotTop);
export default __webpack_public_path__ + "static/media/spot-top.ea33cab66b92ede4a7fb2ef25ddc4bac.svg";
export { ForwardRef as ReactComponent };